import {
  AcademicSystem,
  australiaCountries,
  canadaCountries,
  europeCountries,
  indiaCountries,
  matchAcademicSystemByCountry,
  ukCountries,
  usCountries,
} from './academicCountryGroups';

export const ukClassLevelOptions = [
  'Year R (Reception)', // Age 4–5
  'Year 1', // Age 5–6
  'Year 2 (KS1 SATs)', // Age 6–7
  'Year 3', // Age 7–8
  'Year 4', // Age 8–9
  'Year 5', // Age 9–10
  'Year 6 (KS2 SATs)', // Age 10–11
  'Year 6 (11+ Exam)',
  'Year 7',
  'Year 8',
  'Year 9',
  'Class 10',
  'Year 10 (GCSE - AQA)',
  'Year 10 (GCSE - Edexcel)',
  'Year 10 (GCSE - OCR)',
  'Year 11 (GCSE - AQA)',
  'Year 11 (GCSE - Edexcel)',
  'Year 11 (GCSE - OCR)',
  'Year 10 (IGCSE - CIE)',
  'Year 10 (IGCSE - Edexcel)',
  'Year 11 (IGCSE - CIE)',
  'Year 11 (IGCSE - Edexcel)',
  'Year 12 (AS Level - AQA)',
  'Year 12 (AS Level - CIE)',
  'Year 12 (AS Level - OCR)',
  'Year 13 (A Level - AQA)',
  'Year 13 (A Level - CIE)',
  'Year 13 (A Level - OCR)',
  'IB',
];

export const indiaClassLevelOptions = [
  'Nursery',
  'LKG',
  'UKG',
  'Class 1',
  'Class 2',
  'Class 3',
  'Class 4',
  'Class 5',
  'Class 6',
  'Class 7',
  'Class 8',
  'Class 9',
  'Class 10',
  'Class 11',
  'Class 12',
];

export const usClassLevelOptions = [
  'Pre-K',
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grade 9',
  'Grade 10',
  'Grade 11',
  'Grade 12',
  'AP / College Prep',
];

export const canadaClassLevelOptions = [
  'Junior Kindergarten',
  'Senior Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Grade 9',
  'Grade 10',
  'Grade 11',
  'Grade 12',
  'CEGEP / Pre-University',
];

export const australiaClassLevelOptions = [
  'Prep / Foundation',
  'Year 1',
  'Year 2',
  'Year 3',
  'Year 4',
  'Year 5',
  'Year 6',
  'Year 7',
  'Year 8',
  'Year 9',
  'Year 10',
  'Year 11',
  'Year 12',
];

export const europeClassLevelOptions = [
  'Kindergarten',
  'Year 1',
  'Year 2',
  'Year 3',
  'Year 4',
  'Year 5',
  'Year 6',
  'Year 7',
  'Year 8',
  'Year 9',
  'Year 10',
  'Year 11',
  'Year 12',
  'Year 13',
];

export const classLevelOptions = ukClassLevelOptions;

const classLevelSystems: AcademicSystem<string>[] = [
  {
    countries: indiaCountries,
    label: 'Indian class structure',
    options: indiaClassLevelOptions,
  },
  {
    countries: usCountries,
    label: 'US grade structure',
    options: usClassLevelOptions,
  },
  {
    countries: canadaCountries,
    label: 'Canadian grade structure',
    options: canadaClassLevelOptions,
  },
  {
    countries: australiaCountries,
    label: 'Australia and New Zealand year structure',
    options: australiaClassLevelOptions,
  },
  {
    countries: europeCountries,
    label: 'European year structure',
    options: europeClassLevelOptions,
  },
  {
    countries: ukCountries,
    label: 'UK year structure',
    options: ukClassLevelOptions,
  },
];

const defaultClassLevelSystem: AcademicSystem<string> = {
  countries: [],
  label: 'Default year structure',
  options: ukClassLevelOptions,
};

export const getClassLevelSystemByCountry = (country?: string) => {
  return matchAcademicSystemByCountry(
    country,
    classLevelSystems,
    defaultClassLevelSystem,
  );
};

export const getClassLevelOptionsByCountry = (country?: string) =>
  getClassLevelSystemByCountry(country).options;

export const getClassLevelSystemLabelByCountry = (country?: string) =>
  getClassLevelSystemByCountry(country).label;
